import React from 'react'

interface IColumn {
  key: string | number
  title: string
}

interface IRow {
  key: string | number
  value: string
  onClick?: () => void
}

interface ITableProps extends React.HTMLAttributes<HTMLTableElement> {
  columns: IColumn[]
  rows: IRow[][]
}

const Table: React.FC<ITableProps> = ({ columns, rows, ...rest }) => {
  return (
    <table className='table' {...rest}>
      <thead>
        <tr>
          {columns.map((column) => (
            <th key={column.key}>{column.title}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rows.map((row) => (
          <tr key={row[0].key}>
            {row.map((rowItem) => (
              <td
                onClick={() => rowItem.onClick && rowItem.onClick()}
                className={rowItem.onClick ? 'link' : ''}
                key={rowItem.key}
              >
                {rowItem.value}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  )
}

export default Table
